import {
  AiLoginErrorResponse,
  AiLoginErrorState,
  handleAiLoginError,
} from 'common/helpers/aiLoginError'
import {useCallback, useState} from 'react'

export function useAiLoginError() {
  const [aiLoginError, setAiLoginError] = useState<AiLoginErrorState | null>(null)
  const [emailLoginOnly, setEmailLoginOnly] = useState(false)

  const clearAiLoginError = useCallback(() => {
    setAiLoginError(null)
  }, [])

  const showEmailLoginForm = useCallback((email?: string) => {
    setAiLoginError(null)
    setEmailLoginOnly(true)
    return email ?? ''
  }, [])

  const processAiLoginError = useCallback(
    (
      response: AiLoginErrorResponse,
      onDefaultError: (message: string) => void,
      fallbackMessage = 'Login failed'
    ) => {
      return handleAiLoginError(
        response,
        {
          onAccountNotFound: (message) => {
            setAiLoginError({step: 'account_not_found', message})
          },
          onUseEmailPassword: (message, email) => {
            setAiLoginError({step: 'use_email_password', message, email})
          },
          onSchoolPickerConflict: () => {},
          onDefaultError: (message) => {
            setAiLoginError(null)
            onDefaultError(message)
          },
        },
        fallbackMessage
      )
    },
    []
  )

  return {
    aiLoginError,
    emailLoginOnly,
    setEmailLoginOnly,
    clearAiLoginError,
    showEmailLoginForm,
    processAiLoginError,
  }
}
